import { render, staticRenderFns } from "./OptionItem.vue?vue&type=template&id=d1fcb8e8&scoped=true&"
import script from "./OptionItem.vue?vue&type=script&lang=js&"
export * from "./OptionItem.vue?vue&type=script&lang=js&"
import style0 from "./OptionItem.vue?vue&type=style&index=0&id=d1fcb8e8&prod&lang=scss&scoped=true&"
import style1 from "./OptionItem.vue?vue&type=style&index=1&id=d1fcb8e8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1fcb8e8",
  null
  
)

export default component.exports